import MediaBlockWithWrapText from '.';
import type { Meta, StoryObj } from '@storybook/vue3';
import { Default as Image } from 'ewi-ui/components/1-atoms/Media/Image/Image.stories.ts';
import {
  NativeUpload as VideoDialog,
  Youtube as YoutubeVideoDialog,
} from 'ewi-ui/components/2-molecules/VideoDialog/VideoDialog.stories';

const longText = `
  <h3>Ökostrom und Gas vom Energieanbieter: E WIE EINFACH</h3>
  <p>
    Wir von E WIE EINFACH sind dein Stromanbieter mit 100% Ökostrom. Lerne
    uns außerdem als modernen und digitalen Gasanbieter mit klimaneutralem
    Gas kennen. Der Wechsel zu uns gelingt dir ganz einfach und papierlos.
    Wir von E WIE EINFACH sind dein Stromanbieter mit 100% Ökostrom. Lerne
    uns außerdem als modernen und digitalen Gasanbieter mit klimaneutralem
    Gas kennen. Der Wechsel zu uns gelingt dir ganz einfach und papierlos.
    Wir von E WIE EINFACH sind dein Stromanbieter mit 100% Ökostrom. Lerne
    uns außerdem als modernen und digitalen Gasanbieter mit klimaneutralem
    Gas kennen. Der Wechsel zu uns gelingt dir ganz einfach und papierlos.
    Wir von E WIE EINFACH sind dein Stromanbieter mit 100% Ökostrom. Lerne
    uns außerdem als modernen und digitalen Gasanbieter mit klimaneutralem
    Gas kennen. Der Wechsel zu uns gelingt dir ganz einfach und papierlos.
  </p>
  <p>
    Wir von E WIE EINFACH sind dein Stromanbieter mit 100% Ökostrom. Lerne
    uns außerdem als modernen und digitalen Gasanbieter mit klimaneutralem
    Gas kennen. Der Wechsel zu uns gelingt dir ganz einfach und papierlos.
    Wir von E WIE EINFACH sind dein Stromanbieter mit 100% Ökostrom. Lerne
    uns außerdem als modernen und digitalen Gasanbieter mit klimaneutralem
    Gas kennen. Der Wechsel zu uns gelingt dir ganz einfach und papierlos.
  </p>
`;

const meta = {
  title: 'Molecules/MediaBlockWithWrapText',
  component: MediaBlockWithWrapText,
  tags: ['autodocs'],
  decorators: [
    () => ({
      template: '<div style="padding: 30px;"><story /></div>',
    }),
  ],
  argTypes: {
    background: {
      control: 'select',
      options: ['light', 'lightgrey', 'dark', 'lightblue'],
      description: 'Background color class',
    },
    imagePosition: {
      control: 'select',
      options: ['left', 'right'],
      description: 'Position of the image relative to the text content',
    },
    tag: {
      control: 'select',
      options: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
      description: 'Headline tag level',
    },
    headline: {
      control: 'text',
      description: 'Headline text',
    },
    text: {
      control: 'text',
      description: 'Rich text content (HTML)',
    },
    buttons: {
      table: { disable: true },
    },
    videoDialog: {
      table: { disable: true },
    },
    // Image props
    defaultSrc: {
      control: 'text',
      description: 'Default source image URL',
      table: { category: 'Image' },
    },
    altTag: {
      control: 'text',
      description: 'Alternative text for the image',
      table: { category: 'Image' },
    },
    defaultWidth: {
      control: 'text',
      description: 'Default image width',
      table: { category: 'Image' },
    },
    defaultHeight: {
      control: 'text',
      description: 'Default image height',
      table: { category: 'Image' },
    },
    imageCaption: {
      control: 'text',
      description: 'Caption for the image',
      table: { category: 'Image' },
    },
    imageCaptionPosition: {
      control: 'select',
      options: ['left', 'center', 'right'],
      description: 'Position of the image caption',
      table: { category: 'Image' },
    },
    imageRoundedCorners: {
      control: 'boolean',
      description: 'Round corners for image',
      table: { category: 'Image' },
    },
    imageForceAspectRatio: {
      control: 'select',
      options: ['', '1_1', '16_9', '4_3', '3_4'],
      description: 'Force aspect ratio for the image (cropping will occur)',
      table: { category: 'Image' },
    },
    imageForceAspectRatioMobile: {
      control: 'select',
      options: ['', '1_1', '16_9', '4_3', '3_4'],
      description:
        'Force aspect ratio on image for mobile (cropping will occur)',
      table: { category: 'Image' },
    },
    imageHorizontalFocus: {
      control: 'select',
      options: ['', 'left', 'center', 'right'],
      description: 'Image horizontal focus',
      table: { category: 'Image' },
      if: { arg: 'imageForceAspectRatio', truthy: true },
    },
    imageVerticalFocus: {
      control: 'select',
      options: ['', 'top', 'center', 'bottom'],
      description: 'Image vertical focus',
      table: { category: 'Image' },
      if: { arg: 'imageForceAspectRatio', truthy: true },
    },
    imageSrcset: {
      control: 'object',
      description: 'Responsive image srcset array',
      table: { category: 'Image' },
    },
  },
  args: {
    background: 'light',
    imagePosition: 'left',
    tag: 'h2',
    headline: 'Short Title',
    text: '<p>This is some short text content that will wrap around the image.</p>',
    buttons: [],
    videoDialog: VideoDialog.args,
    ...Image.args,
  },
} satisfies Meta<typeof MediaBlockWithWrapText>;

export default meta;
type Story = StoryObj<typeof meta>;

export const Default: Story = {
  args: {
    headline: 'Short Title',
    text: '<p>This is some short text content that will wrap around the image.</p>',
  },
};

export const WithLongText: Story = {
  args: {
    headline: 'Ich bin eine lange mehrzeilige Headline',
    tag: 'h2',
    text: longText,
  },
};

export const WithLongTextAndButtons: Story = {
  args: {
    headline: 'Ich bin eine lange mehrzeilige Headline',
    tag: 'h2',
    text: longText,
    buttons: [
      {
        title: 'Learn More',
      },
      {
        title: 'Contact Us',
      },
    ],
  },
};

export const WithVideoNative: Story = {
  args: {
    headline: 'Ich bin eine lange mehrzeilige Headline',
    tag: 'h2',
    text: longText,
    videoDialog: VideoDialog.args,
  },
};

export const WithVideoYoutube: Story = {
  args: {
    headline: 'Ich bin eine lange mehrzeilige Headline',
    tag: 'h2',
    text: longText,
    videoDialog: YoutubeVideoDialog.args,
  },
};
